export default "/sunken-drone-eth.8d9aed48b56eccf2b3b27bf477856c90.svg";